
<div class="modal-dialog confirm-dialog">
  <div class="modal-content">
    <form [formGroup]="customerHeadingsForm" (ngSubmit)="save()">
      <div class="modal-header">
        <h4 class="modal-title">{{k2CustomerName}} - Custom Headers</h4>
        <button class="close" type="button" (click)="cancel()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <div *ngIf="loading">
          <md-spinner-block></md-spinner-block>
        </div>
        <div class="row">
          <div class="form-group col-6">
            <label for="customHeader1">Custom Field 1</label>
            <input class="form-control" id="customHeader1" type="text" formControlName="customHeader1" name="name">
          </div>
          <div class="form-group col-6">
            <label for="customHeader2">Custom Field 2</label>
            <input class="form-control" id="customHeader2" type="text" formControlName="customHeader2" name="name2">
          </div>
          <div class="form-group col-6">
            <label for="customHeader3">Custom Field 3</label>
            <input class="form-control" id="customHeader3" type="text" formControlName="customHeader3" name="name3">
          </div>
          <div class="form-group col-6">
            <label for="customHeader4">Custom Field 4</label>
            <input class="form-control" id="customHeader4" type="text" formControlName="customHeader4" name="name4">
          </div>
          <div class="form-group col-6">
            <label for="customHeader5">Custom Field 5</label>
            <input class="form-control" id="customHeader5" type="text" formControlName="customHeader5" name="name5">
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="submit" [disabled]="!customerHeadingsForm.dirty">Save</button>
        <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</div>